import {
  format,
  parseISO,
  setHours,
  setMinutes,
  isBefore,
  isAfter,
  startOfDay,
  getHours,
  getMinutes,
} from "date-fns"
import { useFormContext, Controller } from "react-hook-form"
import { Calendar as CalendarIcon } from "lucide-react"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { Calendar } from "@/components/ui/calendar"
import useCalendarConfig from "@/modules/calendar/stores/use-calendar-config"
import useUserEventSideSheet from "@/modules/calendar/stores/use-user-event-side-sheet"

export default function EventDay() {
  const { isDetails } = useUserEventSideSheet()
  const { watch, setValue, control } = useFormContext()
  const { ranges, currentDate } = useCalendarConfig()
  const { startDate, endDate } = ranges

  const updateDates = (newDate: Date | undefined) => {
    if (!newDate) return
    const currentStartDate = parseISO(watch("startDate"))
    const currentEndDate = parseISO(watch("endDate"))

    const newStartDate = setMinutes(
      setHours(newDate, getHours(currentStartDate)),
      getMinutes(currentStartDate),
    )
    const newEndDate = setMinutes(
      setHours(newDate, getHours(currentEndDate)),
      getMinutes(currentEndDate),
    )

    setValue("startDate", newStartDate.toISOString())
    setValue("endDate", newEndDate.toISOString())
  }

  return (
    <div className="flex w-full items-center justify-start">
      <Controller
        name="startDate"
        control={control}
        render={({ field }) => (
          <Popover>
            <PopoverTrigger
              asChild
              disabled={isDetails}
              className={`${isDetails ? "pointer-events-none" : ""}`}
            >
              <div
                className={`flex w-auto max-w-full items-center justify-start gap-3 text-gray-600 ${
                  isDetails ? "cursor-default" : "cursor-pointer"
                }`}
              >
                <CalendarIcon className="!size-5 text-gray-500" />
                <div className="flex w-full items-center gap-1">
                  <span className="ml-[3px] text-sm font-normal">Día:</span>
                  <span className="text-sm font-semibold first-letter:capitalize">
                    {format(parseISO(field.value), "EEEE d 'de' MMMM 'de' yyyy")}
                  </span>
                </div>
              </div>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={field.value ? parseISO(field.value) : undefined}
                defaultMonth={parseISO(currentDate)}
                onSelect={(date) => updateDates(date)}
                disabled={(date) => {
                  const currentDate = startOfDay(date)
                  const start = startOfDay(parseISO(startDate))
                  const end = startOfDay(parseISO(endDate))
                  return isBefore(currentDate, start) || isAfter(currentDate, end)
                }}
              />
            </PopoverContent>
          </Popover>
        )}
      />
    </div>
  )
}
